import React, { useContext } from "react";
import { productList } from "./productContext";

function CartItem(probs) {
  const item = useContext(productList);
  const { id, title, img, price, total, count } = probs.item;
  return (
    <>
      <div className="row my-2 text-capitalize text-center">
        <div className="col-10 mx-auto col-lg-2">
          <img
            src={img}
            alt="cartProduct"
            style={{ width: "5rem", height: "5rem" }}
            className="img-fluid"
          />
        </div>
        <div className="col-10 mx-auto col-lg-2">
          <span className="d-lg-none">product :</span>
          {title}
        </div>
        <div className="col-10 mx-auto col-lg-2">
          <span className="d-lg-none">price : </span>$ {price}
        </div>
        <div className="col-10 mx-auto col-lg-2 my-2 m-lg-0">
          <div className="d-flex justify-content-center">
            <span
              className="bnt btn-black mx-1"
              onClick={() => {
                item.decreament(id);
              }}
            >
              -
            </span>
            <span className="bnt btn-black mx-1">{count}</span>
            <span
              className="bnt btn-black mx-1"
              onClick={() => {
                item.increament(id);
              }}
            >
              +
            </span>
          </div>
        </div>
        <div className="col-10 mx-auto col-lg-2">
          <div
            className="cart-icon "
            onClick={() => {
              item.removeItem(id);
            }}
          >
            <i className="fas fa-trash"></i>
          </div>
        </div>
        <div className="col-10 mx-auto col-lg-2">
          <strong>total:$ {total}</strong>
        </div>
      </div>
    </>
  );
}

export default CartItem;
